import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestData({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'perfilfrentistas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteData({ payload }) {
  try {
    const { id, params } = payload;

    yield call(api.delete, `perfilfrentistas/${id}`);
    yield put(
      successRemove({ ...params, pesquisalista: true, showadmin: false })
    );

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(t(e)));
    else toast.error(t(erros));
  }
}

export function* store({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.post, 'perfilfrentistas', data);
    yield put(
      successRemove({ ...params, pesquisalista: true, showadmin: false })
    );

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/perfilfrentistas');
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `perfilfrentistas/${id}`);

    data.param5perfilfrentista = JSON.stringify(data.param5perfilfrentista);
    data.param7perfilfrentista = JSON.stringify(data.param7perfilfrentista);

    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'perfilfrentistas', data);
    yield put(
      successRemove({ ...params, pesquisalista: true, showadmin: false })
    );

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/perfilfrentistas');
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'perfilfrentistas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest('@perfilFrentista/DATA_IN_REQUEST', requestData),
  takeLatest('@perfilFrentista/DELETE_DATA', deleteData),
  takeLatest('@perfilFrentista/SUCCESS_REMOVE', requestData),
  takeLatest('@perfilFrentista/STORE_DATA', store),
  takeLatest('@perfilFrentista/FIND_DATA', find),
  takeLatest('@perfilFrentista/UPDATE_DATA', update),
  takeLatest('@perfilFrentista/RECORD_FILTERING', applyedFilters),
]);
